import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Pagination } from "swiper/modules";
import ReactStars from "react-rating-stars-component";
// import { useReactToPrint } from "react-to-print";
import html2canvas from "html2canvas";
import moment from "moment";
// -------------------------Custom Imports
import { useListing } from "@/providers";
import Layout from "@/Components/layout/Layout";
import { DetailsHeaderModal } from "@/Components/Details/DetailsHeaderModal";
import { DetailsImages } from "@/Components/Details/DetailsImages";
import { LodgingHostDetails } from "@/Components/Details/LodgingHostDetails";
import { AirportInfo } from "@/Components/Details/AirportInfo";
import { LodgingDetails } from "@/Components/Details/LodgingDetails";
import { DetailsHeader } from "@/Components/Details/DetailsHeader";
import { PricingDetails } from "@/Components/Details/PricingDetails";
import { AccomodationDetails } from "@/Components/Details/AccomodationDetails";
import { FeatureDetails } from "@/Components/Details/FeatureDetails";
import { DetailsMap } from "@/Components/Details/DeatilsMap";
import { DetailsTerms } from "@/Components/Details/DetailsTerms";
import { BookingForm } from "@/Components/Details/BookingForm";
import WPCalender from "@/Components/Calenders/WPCalender";
// ------------------------------
import "swiper/css";
import "./detail.css";
import "swiper/css/pagination";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "@/styles/ListingDetails.css";
import { PROFILE_IMAGE_SERVER_URL, SERVER_IMAGES_URL } from "@/constants";
import { chatServerInstance } from "@/helpers";
import Swal from "sweetalert2";
import ListingOutOverlay from "@/Components/ui/ListingOutOverlay";

export const DetailsPage = ({ listingDetails }) => {
  const { favoriteListings } = useListing();
  const [isPaymentBoxModal, setIsPaymentBoxModal] = useState(false);
  const [modal, setModal] = useState(false);
  const copyTextRef = useRef(null);
  const userId = JSON.parse(localStorage.getItem("data"))?.id;

  const [booking, setBooking] = useState(false);
  const {
    id = 0,
    nightly_price,
    min_day_booking,
    max_day_booking,
    host,
    no_of_guest,
    reviews,
    similarListings,
    hostListings,
    description,
  } = listingDetails;

  const [guest, setGuest] = useState({
    adults: 0,
    children: 0,
    infants: 0,
    pets: 0,
  });

  const maxGuests = parseInt(no_of_guest); // Example limit
  const totalGuests = Object.entries(guest).reduce(
    (acc, [key, value]) => (key === "pets" ? acc : acc + value),
    0
  );

  const handleIncrement = (event, type) => {
    event.preventDefault();

    // if (totalGuests < maxGuests) {

    setGuest((prevGuest) => ({
      ...prevGuest,
      [type]: prevGuest[type] + 1,
    }));
    // }
    // console.log(type)
  };

  const handleDecrement = (event, type) => {
    event.preventDefault();
    setGuest((prevGuest) => ({
      ...prevGuest,
      [type]: prevGuest[type] > 0 ? prevGuest[type] - 1 : 0,
    }));
  };

  // -------------------------------------------Temp Variables ---------------------------------------------------------
  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const response = await chatServerInstance.get("/bookings", {
          params: { user_id: userId, listing_id: id },
        });
        setBooking(response.data?.length > 0);
      } catch (err) {
        Swal.fire({
          icon: "error",
          text: err.message || "Error fetching bookings!",
        });
      } finally {
        // setLoading(false);
      }
    };

    if (userId && id) {
      fetchBookings();
    }
  }, [userId, id]);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [range, setRange] = useState([]);

  // console.log(range)

  const mergeRanges = useCallback((ranges) => {
    // Sort ranges by startDate
    const sortedRanges = ranges.sort(
      (a, b) => new Date(a.startDate) - new Date(b.startDate)
    );

    const merged = [];
    let currentRange = sortedRanges[0];

    for (let i = 1; i < sortedRanges.length; i++) {
      const nextRange = sortedRanges[i];

      // Check for overlap
      if (currentRange.endDate >= nextRange.startDate) {
        // Merge ranges
        currentRange = {
          startDate: currentRange.startDate,
          endDate: new Date(Math.max(currentRange.endDate, nextRange.endDate)),
          key: `selection`,
        };
      } else {
        merged.push(currentRange);
        currentRange = nextRange;
      }
    }

    // Push the last range
    merged.push(currentRange);

    return merged;
  }, []);

  const parseBlockedDates = useCallback(
    (blockedDates) => {
      // Convert blocked_dates to non-overlapping ranges
      const ranges = blockedDates.map(({ start_date, end_date }) => ({
        startDate: moment(start_date).toDate(),
        endDate: moment(end_date).toDate(),
        key: `selection`,
      }));

      // Merge overlapping ranges
      return mergeRanges(ranges);
    },
    [mergeRanges]
  );

  useEffect(() => {
    if (listingDetails && listingDetails.blocked_dates) {
      const parsedRanges = parseBlockedDates(listingDetails.blocked_dates);
      setRange(parsedRanges);
    }
  }, [listingDetails, parseBlockedDates]);

  const contentRef = useRef(null);
  const reactToPrintFn = async () => {
    try {
      const element = contentRef.current;
      const canvas = await html2canvas(element, { useCORS: true });
      const imgData = canvas.toDataURL("image/png");

      // Open the image in a new tab
      const printWindow = window.open("", "_blank");
      printWindow.document.write(
        "<html><head><title>Print</title></head><body>"
      );
      printWindow.document.write(`<img src="${imgData}" style="width:100%"/>`);
      printWindow.document.write("</body></html>");
      printWindow.document.close();
      printWindow.onload = function () {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      };
    } catch (error) {
      console.error("Error printing:", error);
    }
  };

  // -----------------------------------------------Favourite-----------------------------------------------------

  // Memoizing the favorite state
  const { is_favourite, favorite_id } = useMemo(() => {
    const favourite = favoriteListings.find(
      (listing) => listing?.listing_id === id
    );
    return {
      is_favourite: !!favourite,
      favorite_id: favourite ? favourite.id : id,
    };
  }, [favoriteListings, id]);

  // -----------------------------------------------------------------------------------------------------
  console.log({ listingDetails });
  return (
    <>
      <Layout>
        <div id="wrapper" className="!pt-0">
          <div className="content bg-color !p-0">
            <section id="elem" className="px-2 py-5 bg-color md:py-5">
              <div className="container !w-[auto]" ref={contentRef}>
                <div className="page-container">
                  {modal ? (
                    <>
                      <DetailsHeaderModal
                        modal={modal}
                        setModal={setModal}
                        copyTextRef={copyTextRef}
                      />
                    </>
                  ) : (
                    ""
                  )}
                  <div className="row">
                    <DetailsHeader
                      favorite_id={favorite_id}
                      setModal={setModal}
                      is_favourite={is_favourite}
                      booking={booking}
                      reactToPrintFn={reactToPrintFn}
                    />

                    <DetailsImages />
                  </div>

                  <div className="relative content-wrapper">
                    <div className="col-md-6 main-content">
                      <div className="about-section">
                        <div className="">
                          <LodgingHostDetails />
                        </div>
                        <div className="block !bg-transparent">
                          <div className="block-body !px-0">
                            {/* <h2 className="title">About this stay</h2> */}
                            <div
                              className="p-0 sub-title"
                              dangerouslySetInnerHTML={{ __html: description }}
                            />

                            <AirportInfo />
                          </div>
                        </div>
                      </div>
                      <div className="detail-section">
                        <LodgingDetails />
                      </div>
                      <div id="price-section" className="price-section">
                        <PricingDetails />
                      </div>
                      <div
                        id="accomodation-section"
                        data-path="single-listing-to-accomodation-file"
                        className="accomodation-section"
                      >
                        <div className="flex flex-col block-section">
                          <AccomodationDetails />
                        </div>
                      </div>
                      <div className="flex flex-col features-section">
                        <FeatureDetails />
                      </div>
                      <div className="flex flex-col features-section no-print">
                        <DetailsMap />
                      </div>
                      <DetailsTerms />

                      <>
                        <div id="host-section" className="host-section">
                          <div className="block !bg-transparent">
                            <>
                              <div className="flex flex-wrap items-center justify-between gap-3 px-3 mb-30">
                                <div className="text-left">
                                  <h3 className="sub-title-head">
                                    Availability
                                  </h3>
                                </div>
                                <div>
                                  <i className="fa-solid fa-calendar-days"></i>
                                  The minimum stay is{" "}
                                  <strong style={{ color: "gray" }}>
                                    {min_day_booking}
                                  </strong>
                                </div>
                                <div>
                                  <i className="fa-solid fa-calendar-days"></i>
                                  The maximum stay is{" "}
                                  <strong style={{ color: "gray" }}>
                                    {max_day_booking}
                                  </strong>
                                </div>
                              </div>
                              {/* <div className="calender-box mb-30 no-print calendar-container"> */}
                              <div className="row">
                                <div className="col-md-12">
                                  <WPCalender type={"display"} />
                                </div>
                              </div>
                              {/* </div> */}
                            </>

                            <div
                              style={{ marginTop: "40px" }}
                              className="block-head"
                            >
                              <div className="media">
                                <div className="media-left">
                                  <img
                                    width={70}
                                    height={70}
                                    alt=""
                                    src={
                                      host?.image !== null
                                        ? `${PROFILE_IMAGE_SERVER_URL}/${host?.image}`
                                        : "images/avatar/avatar-bg.png"
                                    }
                                    className="img-circle w-[70px] h-[70px] lazyloaded host-image"
                                  />
                                </div>
                                <div className="media-body">
                                  <h2 className="block-head !p-2">
                                    Hosted by {host?.display_name}
                                  </h2>
                                  <ul className="list-inline profile-host-info sub-title">
                                    <li>
                                      <address>
                                        <i
                                          className="homey-icon homey-icon-style-two-pin-marker"
                                          aria-hidden="true"
                                        />{" "}
                                        {host.country || "United States"}
                                      </address>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            {/* /.block-head */}
                            <div className="block-body">
                              <div className="row">
                                <div className="text-left col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                  <dl>
                                    <dt>Languages</dt>
                                    <dd>{host?.languages?.join(", ")}</dd>
                                  </dl>
                                </div>
                                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                  <dl>
                                    <dt>Profile Status</dt>
                                    <dd className="text-success">
                                      <i className="fa fa-check bg-[#8ec639] p-1 !text-white rounded-full" />
                                      Verified
                                    </dd>
                                  </dl>
                                </div>
                              </div>
                              {/* /.row */}
                              <div className="text-left host-section-buttons">
                                <Link
                                  to={`/user-profile?name=${listingDetails?.host?.display_name}`}
                                  state={{
                                    host_id: listingDetails?.host_id,
                                    email: host?.email,
                                  }}
                                  className="btn btn-half-width"
                                >
                                  View Profile
                                </Link>
                              </div>

                              <h3
                                className="title text-start "
                                style={{
                                  marginTop: "40px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                Reviews:
                                <ReactStars
                                  count={1}
                                  value={1}
                                  //  onChange={ratingChanged}
                                  size={30}
                                  activeColor="#ffd700"
                                />
                                {/* {average_review?.overall_average} ({booking_reviews?.length}) */}
                              </h3>
                              <p
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                All reviews are from verified guests.
                              </p>
                              <div
                                style={{ marginBottom: "50px" }}
                                className="box-widget-item fl-wrap block_box"
                              >
                                <div className="box-widget fl-wrap">
                                  <div className="box-widget-content">
                                    {/*widget-posts*/}
                                    <div className="widget-posts fl-wrap">
                                      {reviews
                                        ?.slice(0, 8)
                                        ?.map((data, index) => {
                                          console.log(data);
                                          const {
                                            rating,
                                            review,
                                            guest: reviewGuest,
                                          } = data;

                                          return (
                                            <div
                                              key={index}
                                              className="flex items-start gap-4 py-4 border-b border-gray-200"
                                            >
                                              {/* Profile Image */}
                                              <div>
                                                <img
                                                  className="object-cover w-12 h-12 rounded-full"
                                                  src={
                                                    reviewGuest?.image !== null
                                                      ? `${PROFILE_IMAGE_SERVER_URL}/${reviewGuest?.image}`
                                                      : "/images/avatar/avatar-bg.png"
                                                  }
                                                  alt="Profile"
                                                />
                                              </div>

                                              {/* Review Content */}
                                              <div className="flex-1">
                                                {/* User Info */}
                                                <div className="flex items-center justify-between">
                                                  <h3 className="!m-0 text-sm font-semibold text-gray-800">
                                                    {reviewGuest?.first_name ||
                                                      "Guest"}
                                                  </h3>
                                                </div>

                                                {/* Comment Text */}
                                                <p className="text-sm text-gray-700  !m-0 !mt-1">
                                                  {review ||
                                                    "No comment provided."}
                                                </p>
                                                <div
                                                  key={index}
                                                  className="flex items-center gap-4 text-sm text-gray-500"
                                                >
                                                  <ReactStars
                                                    count={5}
                                                    value={rating || 0}
                                                    size={20}
                                                    activeColor="#ffd700"
                                                    edit={false}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                          );
                                        })}
                                    </div>

                                    {/* widget-posts end*/}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="block-body">
                              <div className="overflow-hidden container_similar">
                                <h3 className="title text-start pt-30">
                                  Similar Stays
                                </h3>
                                <div className="flex flex-row gap-3 overflow-x-scroll overflow-y-hidden">
                                  {similarListings?.map((e, index) => (
                                    <ListingOutOverlay e={e} type="similar" />
                                  ))}
                                </div>
                              </div>

                              <div className="overflow-hidden container_similar">
                                <h3 className="title text-start pt-30">
                                  {host?.display_name || "Host"}'s Other Stays
                                </h3>

                                <div className="flex flex-row gap-3 overflow-x-scroll overflow-y-hidden">
                                  {hostListings?.map((e, index) => (
                                    <ListingOutOverlay e={e} type="similar" />
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    </div>
                    {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------ */}
                    <div className="hidden lg:block h-[fit-content] col-md-6 mt-6 sticky-container sticky top-0">
                      <div className="sticky top-[30px]">
                        <BookingForm
                          setStartDate={setStartDate}
                          setEndDate={setEndDate}
                          startDate={startDate}
                          endDate={endDate}
                          handleDecrement={handleDecrement}
                          handleIncrement={handleIncrement}
                          totalGuests={totalGuests}
                          guest={guest}
                          maxGuests={maxGuests}
                        />
                      </div>
                    </div>
                    {/* ------------------------------------------------------------------------------------------------------------------------------------------------------------ */}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>

        {isPaymentBoxModal && (
          <div
            style={{ zIndex: 10000000, height: "100vh" }}
            className="fixed flex items-center justify-center w-full bg-black bg-opacity-50"
          >
            <div className="bg-white w-11/12 max-w-md mx-auto rounded-lg shadow-lg p-6 relative !top-[-2rem] h-[600px] overflow-scroll">
              <button
                onClick={() => setIsPaymentBoxModal(false)}
                className="absolute text-xl text-gray-500 top-2 right-2 hover:text-gray-800"
              >
                ✕
              </button>
              <BookingForm
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                startDate={startDate}
                endDate={endDate}
                handleDecrement={handleDecrement}
                handleIncrement={handleIncrement}
                totalGuests={totalGuests}
                guest={guest}
                maxGuests={maxGuests}
              />
            </div>
          </div>
        )}
      </Layout>

      <div
        style={{ zIndex: 100000 }}
        className="sticky bottom-0 left-0 flex items-center justify-between w-full px-6 py-4 bg-white border-t border-gray-300 shadow-lg lg:hidden"
      >
        <div>
          <span className="text-lg font-semibold">${nightly_price}</span>
          <span className="text-sm text-gray-500">/Night</span>
        </div>
        <button
          className="bg-[#8ec639]  hover:bg-green-600 text-white text-sm font-semibold py-2 px-4 rounded-lg"
          onClick={() => setIsPaymentBoxModal(true)}
        >
          Request to Book
        </button>
      </div>
    </>
  );
};
